import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash";
import "../Matching/matching.scss";
import FilterIcon from "src/assets/icons/icon-filter.svg";
import {
    clearModalContent,
    setModalContent,
} from "src/redux/modules/modalEvent";
import ApplyFilterModal from "./ApplyFilterModal";
import { AvailabilityFilter } from "src/components/modules/ClinitianAvailabilityFilter/CAFilterContainer";
import { DefaultAvailabilityFilter } from "src/components/base/TimePicker/TimePicker";
import { getScheduleFilter } from "../Services/FilterHelperService";
import { Typography } from "src/latest/src/components";

export type CombinedFiltersToApply = {
    searchUpdatedFilter: any;
    scheduleFilter: any;
    availabilityFilter: any;
};

type Props = {
    selectedFilters: object;
    searchUpdatedFilter: object;
    calenderServiceFilters: Array<any>;
    scheduleFilterObject: any;
    selectedTherapist?: string;
    applyFilter: (filters: CombinedFiltersToApply) => void;
};

export default function ApplyFilterContainer({
    selectedFilters,
    searchUpdatedFilter,
    calenderServiceFilters,
    scheduleFilterObject,
    selectedTherapist,
    applyFilter,
}: Props) {
    const dispatch = useDispatch();
    const [_selectedFilters, setSelectedFilters] = useState<any>();
    const [_searchUpdatedFilter, setSearchUpdatedFilters] =
        useState(searchUpdatedFilter); // filters that are applied by user
    const [_calenderServiceFilters] = useState(calenderServiceFilters);
    const [_availabilityFilter, setAvailabilityFilters] =
        useState<AvailabilityFilter>(DefaultAvailabilityFilter);
    const [_scheduleFilterObject, setScheduleFilterObject] = useState<any>(
        DefaultAvailabilityFilter
    );
    const [_combinedFilters, setCombinedFilters] =
        useState<CombinedFiltersToApply>();

    let _updatedScheduleFilterData: any;

    useEffect(() => {
        setScheduleFilterObject(scheduleFilterObject);
        setSelectedFilters(_.cloneDeep(selectedFilters));
    }, []);

    let combinedFilters: CombinedFiltersToApply = {
        searchUpdatedFilter: _combinedFilters?.searchUpdatedFilter || undefined,
        scheduleFilter: _combinedFilters?.scheduleFilter || undefined,
        availabilityFilter: _combinedFilters?.availabilityFilter || undefined,
    };

    function setSearchUpdatedFilter(params: any) {
        setSearchUpdatedFilters(params);

        combinedFilters = {
            ...combinedFilters,
            searchUpdatedFilter: params,
        };
    }

    function handleScheduleFilterUpdate(
        filter: any,
        selectedValue: any[],
        currentFilter: any
    ) {
        const prevScheduleFilterObject = _.cloneDeep(
            _updatedScheduleFilterData || _scheduleFilterObject
        );

        _updatedScheduleFilterData =
            getScheduleFilter(prevScheduleFilterObject, selectedTherapist, {
                filter,
                selectedValue,
                currentFilter,
            }) || prevScheduleFilterObject;

        setScheduleFilterObject(_.cloneDeep(_updatedScheduleFilterData));
        combinedFilters = {
            ...combinedFilters,
            scheduleFilter: _.cloneDeep(_updatedScheduleFilterData),
        };
    }

    function handleSelectedFilterUpdate(updatedFilterState: any) {
        if (updatedFilterState) {
            setSelectedFilters(_.cloneDeep(updatedFilterState));
        }
    }

    function handleCalenderAvailabilityFilter(params: any) {
        setAvailabilityFilters(Object.assign({}, params));
        combinedFilters = {
            ...combinedFilters,
            availabilityFilter: params,
        };
    }

    function handleApplyFilter() {
        if (applyFilter) {
            setCombinedFilters(combinedFilters);
            applyFilter(combinedFilters);
            dispatch(clearModalContent());
        }
    }

    const showFilterModal = async () => {
        dispatch(
            setModalContent({
                modalContent: (
                    <ApplyFilterModal
                        selectedFilters={_selectedFilters}
                        searchUpdatedFilter={_searchUpdatedFilter}
                        calenderServiceFilters={_calenderServiceFilters}
                        availabilityFilter={_availabilityFilter}
                        setSearchUpdatedFilter={(params: any) => {
                            setSearchUpdatedFilter(params);
                        }}
                        handleAvailabilityFilter={(params: any) => {
                            handleCalenderAvailabilityFilter(params);
                        }}
                        handleScheduleFilterUpdate={(
                            filter: any,
                            selectedValue: any,
                            currentFilter: any
                        ) => {
                            handleScheduleFilterUpdate(
                                filter,
                                selectedValue,
                                currentFilter
                            );
                        }}
                        applyFilter={handleApplyFilter}
                        handleSelectedFilterUpdate={(updatedFilters: any) => {
                            handleSelectedFilterUpdate(updatedFilters);
                        }}
                    />
                ),
                size: "sm",
                title: (
                    <Typography color="color-28" variant="size-20">
                        Filter Clinicians
                    </Typography>
                ),
                isGeneralPopup: true,
                backDrop: "static",
            })
        );
    };

    return (
        <>
            <div
                className="mobile-filter-icon d-block"
                onClick={() => showFilterModal()}
            >
                <img src={FilterIcon} alt={"filters"} />

                <div
                style={{
                    height: "8px",
                    width: "8px",
                    borderRadius: "50%",
                    background: "#f06565",
                    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.15)",
                    position: "absolute",
                    top: "9px",
                    right: "59px",
                }}
            />
            </div>
        </>
    );
}
